import React from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Button, Flex, Text } from "@paguelofacil/pf-components";

import LogoZinli from "../../assets/images/logo-zinli-button.svg";
import LogoPf from "../../assets/images/logo-pf-button.svg";
import { language, languageDefault } from "../../services/utils/Language";

export const BoxInit = () => {
    const navigate = useNavigate();

    const onNavigate = path => {
        navigate(path);
    };

    return (
        <Flex
            align="center"
            direction="column"
            gap="2rem"
            justify="space-between"
            className="container-box-init"
            minW="auto"
        >
            <Text className="title-home">
                <FormattedMessage id={language.title_home} defaultMessage={languageDefault.title_home} />
            </Text>
            <Button
                className="button-init button-zinli"
                size="md"
                handleClick={() => onNavigate("/cryptofacil/zinli")}
                leftIcon={<img src={LogoZinli} alt="logo zinli" loading="lazy" />}
            >
                <FormattedMessage
                    id={language.title_first_button}
                    defaultMessage={languageDefault.title_first_button}
                />
            </Button>
            <Button
                size="md"
                className="button-init"
                handleClick={() => onNavigate("/cryptofacil/pf")}
                leftIcon={<img src={LogoPf} alt="logo pf" loading="lazy" />}
            >
                <FormattedMessage
                    id={language.title_second_button}
                    defaultMessage={languageDefault.title_second_button}
                />
            </Button>
        </Flex>
    );
};
